import { render } from "./AlbumsCTA.vue?vue&type=template&id=7a2e5066&scoped=true"
import script from "./AlbumsCTA.vue?vue&type=script&lang=js"
export * from "./AlbumsCTA.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2e5066"]])

export default __exports__